import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

import "../styles/style.scss";

gsap.registerPlugin(ScrollTrigger);

/*
Add any JavaScript for your template
*/
$(window).on("acf/loaded/animated-logo", () => {
	initAnimatedLogos('.interface-interface-skeleton__content');
});

window.addEventListener("DOMContentLoaded", () => {
	if ($('#editor').length === 0) {
		initAnimatedLogos();
	}
});

function initAnimatedLogos(scrollerTarget = window) {
	const animatedElements = document.querySelectorAll('[data-animated="true"]');
	
	// Iterate over each animated element and apply animation
	animatedElements.forEach((element) => {
		const elementId = element.getAttribute('data-id');
		
		// Define a timeline for each element
		const tl = gsap.timeline({
			defaults: { ease: "none" },
			scrollTrigger: {
				trigger: element,
				start: "top center",
				end: "bottom top",
				scrub: true,
				scroller: scrollerTarget
			},
			repeat: 0,
			repeatDelay: 1
		});
		
		tl.fromTo(`#${elementId} .outter-incomplete-circle`, 
			{ rotation: 145, fill: "#FFFFF", transformOrigin: "center", opacity: 1 }, 
			{ rotation: 0, ease: "sine.in", duration: 0.5, opacity: 1 }
		)
		.fromTo(`#${elementId} .small-solid-circle`, 
			{ opacity: 0, fill: "#FFFFF" }, 
			{ opacity: 1, ease: "sine.in", duration: 0.5 }
		)
		.fromTo(`#${elementId} .inner-full-circle`, 
			{ opacity: 0, fill: "#FFFFF" }, 
			{ opacity: 1, ease: "sine.in", duration: 0 }
		)
		.fromTo([`#${elementId} .letters-u-p`, `#${elementId} .piv_t-up`, `#${elementId} .technologies-svg`],
			{ opacity: 0, y: 0, x: 0, stroke: "#FFFFFF", fill: "#FFFFF" },
			{ opacity: 1, y: 0, x: 0, ease: "Sine.easeInOut", duration: 0.5 }
		);
	});
}
